import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { EndPoint } from "@endpoint";
import { LoginServices } from "@login";
import { BasePostProvider } from "@tendercuts/http";
import {
  GenerateTripSheetResponse,
  GenericServerResponse,
} from "@tendercuts/models";

@Injectable({
  providedIn: "root",
})
export class TripSheetPenaltyService extends BasePostProvider<GenerateTripSheetResponse> {
  constructor(
    public http: HttpClient,
    public endpointService: EndPoint,
    public loginService: LoginServices,
  ) {
    super(http);
  }

  get isAuthenticatedEndpoint(): boolean {
    return true;
  }

  get authProtocol(): LoginServices {
    return this.loginService;
  }

  get model(): typeof GenerateTripSheetResponse {
    return GenerateTripSheetResponse;
  }

  get isCachable(): boolean {
    return false;
  }

  get endpoint(): string {
    return this.endpointService.tripSheetPenalty();
  }

  /**
   *
   * @param id
   * @param amount
   * @param comment
   */
  getParams(
    id: number,
    amount: number,
    comment: string,
  ): {
    sheet_id: number;
    penalty_amount: number;
    comment: string;
  } {
    return {
      sheet_id: id,
      penalty_amount: amount,
      comment,
    };
  }
}
